export default "__VITE_ASSET__Tr6_Fd9k__"